// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2af9e","content":"styles_content__2Zctb","checkbox":"styles_checkbox__3DSLM","checkboxLabel":"styles_checkboxLabel__1oIUe"};